var _g, _g2, _rect, _rect2, _rect3, _rect4, _line, _line2, _rect5, _rect6, _rect7, _rect8, _text, _text2, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3,3)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 38,
    width: 156,
    height: 148,
    rx: 12,
    fill: "#00FFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3,-3)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 38,
    width: 156,
    height: 148,
    rx: 12,
    fill: "#FF00FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 38,
    width: 156,
    height: 148,
    rx: 12,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 41,
    width: 156,
    height: 148,
    rx: 12,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 38,
    width: 156,
    height: 44,
    rx: 12,
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 3.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 41,
    width: 156,
    height: 44,
    rx: 12,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 68,
    x2: 178,
    y2: 68,
    stroke: "#CC00CC",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 71,
    x2: 181,
    y2: 71,
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 18,
    width: 14,
    height: 34,
    rx: 7,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 21,
    width: 14,
    height: 34,
    rx: 7,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 20,
    width: 14,
    height: 34,
    rx: 7,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 23,
    width: 14,
    height: 34,
    rx: 7,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 158,
    fontFamily: "'Courier New', monospace",
    fontSize: 72,
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 5,
    textAnchor: "middle",
    fontWeight: "bold"
  }, "1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 161,
    fontFamily: "'Courier New', monospace",
    fontSize: 72,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2.5,
    textAnchor: "middle",
    fontWeight: "bold"
  }, "1")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 60,
    fontFamily: "'Courier New', monospace",
    fontSize: 14,
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3,
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 3
  }, "MON")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 103,
    y: 63,
    fontFamily: "'Courier New', monospace",
    fontSize: 14,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 3
  }, "MON")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.94a5bcd86ec00f3432e23aa1a02d6f26.svg";
export { ForwardRef as ReactComponent };